import styled from 'styled-components/native'

import { Box } from 'widgets/Box'
import { TextInput } from 'widgets/TextInput'

type ContainerProps = {
  focused?: boolean
  disabled?: boolean
  type?: 'light' | 'dark'
}

export const StyledButtonContainer = styled(Box)<ContainerProps>`
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.colors.grey : theme.colors.v2primary};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.sm}px;
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.sm + 1}px;
  border: 2px solid
    ${({ disabled, theme }) => (disabled ? theme.colors.grey : theme.colors.v2primary)};
`

export const StyledTextInput = styled(TextInput)<ContainerProps>`
  flex: 1;
  ${({ theme, type }) => type && type === 'light' && `color: ${theme.colors.black}`}
  ${({ theme, type }) => type && type === 'light' && `background-color: ${theme.colors.white}`}
  ${({ theme, type }) => type && type === 'light' && `border: 2px solid ${theme.colors.grey}`}
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-width: 0;
  font-size: ${({ theme }) => theme.fonts.sizes.sm + 1}px;
`
